namespace Portico.Tfs {
    export class TfsBuildDefinitionService {
        constructor(private $http: angular.IHttpService, private settings: ITfsSettings) {}

        private request<T>(method: string, url: string, data?: any): ng.IPromise<T> {
            url = `/${this.settings.project}/_apis/build${url}`;

            return this.$http<T>(tfsRequest({ method, url, data }, this.settings, '2.0')).then(
                x => x.data
            );
        }

        public list(criteria: Build.Definition.List.Request) {
            const items: string[] = [];
            for (let key of Object.keys(criteria)) {
                if (Array.isArray(criteria[key])) {
                    criteria[key] = criteria[key].join(',');
                }
                items.push(`${key}=${criteria[key]}`);
            }
            let url = '/definitions';
            if (items.length > 0) {
                url += '?' + items.join('&');
            }
            return this.request<Build.Definition.List.Response>('get', url);
        }

        public async find(
            criteria: Build.Definition.List.Request,
            func: (build: Build.Definition.List.Value) => boolean
        ) {
            const builds = await this.list(criteria);
            const found = _.find(builds.value, func);
            if (found) return await this.get(found.id);
        }

        public get(id: number) {
            let url = `/definitions/${id}`;
            return this.request<Build.Definition.Get.Response>('get', url);
        }

        public revision(id: number, revision: number) {
            const url = `/definitions/${id}?revision=${revision}`;
            return this.request<Build.Definition.Get.Response>('get', url);
        }

        public create(request: Tfs.Build.Definition.Create.Request) {
            const url = `/definitions`;
            return this.request<Build.Definition.Get.Response>('post', url, request);
        }

        public update(id: number, request: Tfs.Build.Definition.Update.Request) {
            const url = `/definitions/${id}`;
            return this.request<Build.Definition.Get.Response>('put', url, request);
        }

        public delete(id: number) {
            const url = `/definitions/${id}`;
            return this.request<void>('delete', url);
        }

        public revisions(id: number) {
            const url = `/definitions/${id}/revisions`;
            return this.request<Build.Definition.History.Response>('get', url);
        }

        public options() {
            const url = `/options`;
            return this.request<Build.Definition.History.Response>('get', url);
        }
    }
}
